var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2356_286022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.0195C10.8593 14.0195 14 10.8789 14 7.01953C14 3.1602 10.8594 0.0195312 7 0.0195312C3.14063 0.0195312 0 3.1602 0 7.01953C0 10.8789 3.14067 14.0195 7 14.0195ZM7 0.952849C10.346 0.952849 13.0667 3.67351 13.0667 7.01953C13.0667 10.3656 10.346 13.0862 7 13.0862C3.65398 13.0862 0.933318 10.3656 0.933318 7.01953C0.933318 3.67351 3.65401 0.952849 7 0.952849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04153 9.25C9.12788 9.31998 9.23052 9.35268 9.3332 9.35268C9.47086 9.35268 9.60619 9.29201 9.69718 9.17768C9.85819 8.977 9.82549 8.683 9.62486 8.522L7.46652 6.79533V3.28599C7.46652 3.02932 7.25653 2.81934 6.99986 2.81934C6.74319 2.81934 6.5332 3.02932 6.5332 3.28599V7.01934C6.5332 7.16169 6.59855 7.29468 6.7082 7.38333L9.04153 9.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2356_286022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.0195312)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer-icon.e5d618e3.svg";
export { ForwardRef as ReactComponent };